<template>
  <div class="app-container">
    <component :is="currentList" :orders="orders"></component>
  </div>
</template>

<script>
import Available from './components/Available';
import config from '@/config/index'
import Unavailable from './components/Unavailable';
import { getStopCarInfoByMac } from '@/api/park';
import { getTimeval, deepClone, getUrlParam, parseTime } from '@/utils';
import { mapGetters } from 'vuex';

export default {
  name: 'Temporary-Parking-Cost-Doorway',
  components: { Available, Unavailable },
  computed: {
    ...mapGetters(['wx_userInfo', 'wx_token', 'token'])
  },
  data () {
    return {
      getInfo_Loading: null,
      currentList: 'Unavailable',
      orders: {},
      config
    }
  },
  mounted () {
    this.componentsValve()
  },
  methods: {
    componentsValve () {
      let _this = this
      let params = {
        mac: _this.$route.query.mac || getUrlParam('mac')
      }
      _this.getInfo_Loading = _this.$toast.loading('加载中...')
      getStopCarInfoByMac(params)
        .then(response => {
          let data = response.body
          if (data.entranceDate) {
            let exitDate = data.exitDate || parseTime(new Date())
            data.parkingTime = getTimeval(data.entranceDate, exitDate)
          }
          if (Object.keys(data).length > 0) {
            _this.orders = deepClone(data)
            _this.currentList = 'Available'
          } else {
            _this.currentList = 'Unavailable'
            if (this.$enumObject.providerConfig[config.projectName].otherConfig.GoBill) {
              this.$router.replace({ name: 'Arrears-Bill-Temporary', query: { cardNumber: params.cardNumber } })
            }
          }
          _this.getInfo_Loading.clear()
        })
        .catch(error => {
          _this.getInfo_Loading.clear()
          _this.currentList = 'Unavailable'
          _this.$notify({
            type: 'danger',
            message: error
          })
        })
    }
  }
}
</script>
